module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("Новости")]), _vm._v(" "), _vm._l((_vm.commonData.news), function(item, key) {
    return (_vm.commonData.isLoaded == true) ? _c('div', {
      key: key,
      staticStyle: {
        "width": "900px",
        "margin-bottom": "40px"
      }
    }, [(item.publish == true) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "100%",
        "font-family": "'Roboto Thin'",
        "font-size": "22px",
        "padding-bottom": "5px",
        "float": "left"
      }
    }, [_c('span', {
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "font-size": "13px",
        "padding-bottom": "20px",
        "float": "left"
      }
    }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(item.createdAt)) + "    " + _vm._s(_vm.commonData.users[item.author].Name) + "\n    ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "font-size": "15px",
        "padding-bottom": "15px",
        "float": "left"
      },
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100px",
        "border-bottom": "1px dotted #ccc",
        "clear": "left"
      }
    }, [_vm._v("\n       \n    ")])]) : _vm._e()]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1483854a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 388
// module chunks = 0